<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('cartographie.title')}}</h1>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div>
            <qd-button
                class="mgr-2 button btn-modal-annuler"
                :class="{'button-access-no-permission': activeStep === 0}"
                type="is-cancel"
                :disabled="activeStep === 0"
                @click="() => activeStep -= 1">
                {{$t('general.button.precedent')}}
            </qd-button>
            <qd-button
                :class="{'button-access-no-permission': activeStep === numberSteps - 1}"
                type="is-addOrEdit"
                :disabled="activeStep === numberSteps - 1"
                @click="() => activeStep += 1">
                {{$t('general.button.suivant')}}
            </qd-button>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-40px">
        <qd-steps
          class="step_expanded"
          v-model="activeStep"
          :animated="true"
          :has-navigation="false"
          :destroy-on-hide="true"
          label-position="bottom"
          :stepsItems="stepsItems">
          <template #recherche>
            <recherche-cartographie :selection="selection"/>
          </template>
          <template #selection>
            <selection-cartographie :selection="selection"/>
          </template>
          <template #carte>
            <carte-cartographie :selection="selection">
              <template v-slot:produitFaces="{ mark }">
                <face-cards :mark="mark" />
              </template>
              <template v-slot:produitEcrans="{ mark }">
              <ecran-cards :mark="mark" />
              </template>
              <template v-slot:materiels="{ mark }">
                <face-cards :mark="mark" />
              </template>
              <template v-slot:clients="{ mark }">
                <client-cards :mark="mark" />
              </template>
            </carte-cartographie>
          </template>
      </qd-steps>
    </div>
  </div>
</template>

<script>
import rechercheCartographie from '@/components/outils/cartographie/rechercheCartographie';
import selectionCartographie from '@/components/outils/cartographie/selectionCartographie';
import carteCartographie from '@/components/outils/cartographie/carteCartographie';
import faceCards from '@/components/outils/cartographie/cards/faceCards';
import clientCards from '@/components/outils/cartographie/cards/clientCards';
import ecranCards from '@/components/outils/cartographie/cards/ecranCards';

export default {
  data() {
    return {
      activeStep: 0,
      numberSteps: 3,
      selection: {
        produitFaces: [],
        clients: [],
        reseaux: [],
        produitEcrans: [],
      },
    };
  },
  components: {
    rechercheCartographie,
    selectionCartographie,
    carteCartographie,
    faceCards,
    clientCards,
    ecranCards,
  },
  computed: {
    numberSelected() {
      return Object.values(this.selection).map(v => v.length).reduce((a, l) => {
        const result = a + l;
        return result;
      }, 0);
    },
    stepsItems() {
      return [
        {
          name: 'recherche',
          step: 1,
          label: this.$t('cartographie.steps.recherche'),
          clickable: true,
        },
        {
          name: 'selection',
          step: 2,
          label: this.$t('cartographie.steps.selection', { num: this.numberSelected }),
          clickable: true,
        },
        {
          name: 'carte',
          step: 3,
          label: this.$t('cartographie.steps.carte'),
          clickable: true,
        },
      ];
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.outils.cartographie'));
  },
};
</script>

<style>
  .step_expanded .step-items {
    width: 100%;
  }
</style>
